module.exports = __webpack_public_path__ + "img/tag.7886df0e.svg";